import { type TagColor } from '@/components/Tag/Tag'
import i18n from '@/i18n'

import type { ClassAbsenceStatus } from './absences-statuses'

export const getAbsencesStatusTag = (
  value: ClassAbsenceStatus
): { color: TagColor; label: string } => {
  switch (value) {
    case 'unexcused':
      return {
        color: 'red',
        label: i18n.t('statuses.unexcused', { ns: 'classes' })
      }
    case 'excused':
      return {
        color: 'green',
        label: i18n.t('statuses.excused', { ns: 'classes' })
      }
    case 'guardian_review':
      return {
        color: 'blue',
        label: i18n.t('statuses.guardian_review', { ns: 'classes' })
      }
    case 'pending':
      return {
        color: 'orange',
        label: i18n.t('statuses.pending', { ns: 'classes' })
      }
    default:
      return {
        color: 'gray',
        label: i18n.t('label.unverified', { ns: 'classes' })
      }
  }
}
